import { call, put, select } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { setValidatorsObjectProperties } from "./actions";
import { getValidatorsObjectPropertiesRequest } from "./api";
import { validatorsObjectPropertiesSelector } from "./selectors";


const validatorsSchema = new schema.Entity("validators", undefined , { idAttribute: "code" });
const validatorsListSchema = new schema.Array(validatorsSchema);

function* getValidatorsObjectPropertiesWorker() {
    try {
        const { ids } = yield select(validatorsObjectPropertiesSelector);
        if(!ids.length){
            yield put(setValidatorsObjectProperties({ isLoading: true }));
            const { validators } = yield call(getValidatorsObjectPropertiesRequest);
            const { result, entities } = normalize(validators, validatorsListSchema);
            yield put(setValidatorsObjectProperties({
                isLoading: false,
                validators: entities.validators,
                ids: result
            }));
        }
    } catch (error) {
        yield put(setValidatorsObjectProperties({ isLoading: true }));
        showError(error);
    }
}

export function* getValidatorsObjectProperties() {
    yield call(getValidatorsObjectPropertiesWorker);
}
